module.exports = __webpack_public_path__ + "static/img/cartoon-cat.5890c861.png";